import { Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from 'environments/environment';

@Component({
  selector: 'child-onboarding-docs',
  imports: [TranslocoPipe],
  templateUrl: './docs.component.html',
})
export class DocsComponent {
  public readonly onboardingId = input<string>();
  public readonly docs = ['CONTRACT', 'CRS', 'SOLE_REPRESENTATION_AUTHORIZATION'];
  public readonly pdfPrefix = `${environment.apihost}/api/child-onboarding/previewpdf/`;
}
